var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlan(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2239_9430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9466 28.0106C56.0959 31.5731 55.8061 35.1405 55.0836 38.6322C53.1099 47.9503 47.1335 53.945 36.9525 55.2486C30.2363 56.2372 23.398 56.0258 16.7558 54.6244C13.7989 54.0379 11.0349 52.7235 8.71381 50.7999C6.39277 48.8764 4.58795 46.4046 3.46264 43.608C1.76166 39.4784 0.915334 35.0469 0.974774 30.5811C0.784157 26.3208 1.07363 22.0527 1.83772 17.8572C3.80231 9.13584 8.19969 4.28863 17.123 2.14043C24.5826 0.331933 32.3663 0.331933 39.8259 2.14043C48.7676 4.28863 53.1925 9.1542 55.0836 17.848C55.8334 21.1803 56.1238 24.5996 55.9466 28.0106Z",
    fill: "#BFF4FB"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2239_9430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.8842 39.3333C34.1352 40.91 32.5282 42 30.6666 42H19.9999C17.4226 42 15.3333 39.9107 15.3333 37.3333V22.6667C15.3333 20.3046 17.0882 18.3524 19.3653 18.0428C19.3441 18.2479 19.3333 18.456 19.3333 18.6667V33.3333C19.3333 36.647 22.0195 39.3333 25.3333 39.3333H34.8842ZM35.3333 14C35.5014 14.1194 35.6529 14.2629 35.782 14.4278L40.6666 20.6667H36.0596C35.6585 20.6667 35.3333 20.3499 35.3333 19.9592V14Z",
    fill: "#06A4B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.0001 14V20C34.0001 21.1046 34.8955 22 36.0001 22H40.6667V33.3333C40.6667 35.9107 38.5774 38 36.0001 38H25.3334C22.7561 38 20.6667 35.9107 20.6667 33.3333V18.6667C20.6667 16.0893 22.7561 14 25.3334 14H34.0001ZM30.0001 26H26.6667C26.2986 26 26.0001 26.2985 26.0001 26.6667C26.0001 27.0349 26.2986 27.3333 26.6667 27.3333H30.0001V30.6667C30.0001 31.0349 30.2986 31.3333 30.6667 31.3333C31.0349 31.3333 31.3334 31.0349 31.3334 30.6667V27.3333H34.6667C35.0349 27.3333 35.3334 27.0349 35.3334 26.6667C35.3334 26.2985 35.0349 26 34.6667 26H31.3334V22.6667C31.3334 22.2985 31.0349 22 30.6667 22C30.2986 22 30.0001 22.2985 30.0001 22.6667V26Z",
    fill: "#06A4B2"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2239_9430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2239_9430"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25.3333,
    height: 28,
    fill: "white",
    transform: "translate(15.3333 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlan);
export default __webpack_public_path__ + "static/media/plan.42d1e5ba6a600620c1e631c5f0a5d00b.svg";
export { ForwardRef as ReactComponent };